<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Computer Engineering"
                   :links="[{title:'Home', url:'/'},{title:'Faculty'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="4"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">Faculty</div>
          <faculty-card class="mb-5"
                        v-for="(faculty, index) in facultyList"
                        :key="index"
                        :faculty="faculty"
                        :dir="dirName"></faculty-card>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/computer/Sidebar";
import FacultyCard from "@/components/FacultyCard";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "Faculty",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    FacultyCard,
    KeyRecruiters
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      dirName: 'computer',
      facultyList: [
        {
          name: 'Prof. Chandgude A. S.',
          cv: 'test.pdf',
          image: 'Chandgude_AS',
          designation: 'Assistant Professor & HOD',
          qualification: 'M.Tech(CSE), Ph.D*,',
          experience: '12 Years',
          specialization: 'Machine Learning',
          contact: '9552218363',
          email: 'amarschandgude1445@gmail.com'
        },
        {
          name: 'Prof. Pandav R. M.',
          cv: 'test.pdf',
          image: 'employee_placeholder_male',
          designation: 'Assistant Professor',
          qualification: 'M. Tech (CSE)',
          experience: '12 years',
          specialization: 'Information Security',
          contact: '9096348245',
          email: 'roshan.pandav67@gmail.com'
        },
        {
          name: 'Prof. Dhakane V. N.',
          cv: 'test.pdf',
          image: 'Dhakane_VN',
          designation: 'Assistant Professor',
          qualification: 'M. Tech (IT) Ph.D*',
          experience: '11 Years',
          specialization: 'Compiler',
          contact: '7387939971',
          email: 'vikasdhakane@gmail.com'
        },
        {
          name: 'Prof. Gaikwad S.B.',
          cv: 'test.pdf',
          image: 'Gaikwad_S.B',
          designation: 'Assistant Professor',
          qualification: 'M.E (ETRX)',
          experience: '11 years',
          specialization: 'Electronics',
          contact: '7841830068',
          email: 'Gaikwadsumitra3@gmail.com'
        },
        {
          name: 'Prof. Dalvi A. S.',
          cv: 'test.pdf',
          image: 'Dalvi_AS',
          designation: 'Assistant Professor',
          qualification: 'M.E(COMP)',
          experience: '02 Years',
          specialization: 'Embedded System & IOT',
          contact: '8805032322',
          email: 'arundalvi20@gmail.com'
        },
        {
          name: 'Prof. Bornare R. R.',
          cv: 'test.pdf',
          image: 'Bornare_RR',
          designation: 'Assistant Professor',
          qualification: 'M.E(COMP)',
          experience: '02 Years',
          specialization: 'Data Structure',
          contact: '9657465873',
          email: 'rahkibornare013@gmail.com'
        },
        {
          name: 'Prof. Patil P.A.',
          cv: 'test.pdf',
          image: 'Patil_P.A',
          designation: 'Assistant Professor',
          qualification: 'M.E(COMP)',
          experience: '05 Years',
          specialization: 'Network & Security',
          contact: '9860724373',
          email: 'mail2pradippatil@gmail.com'
        },
        {
          name: 'Prof. Kanade P. G.',
          cv: 'test.pdf',
          image: 'employee_placeholder_male',
          designation: 'Assistant Professor',
          qualification: 'M.E(COMP)',
          experience: '01 Years',
          specialization: 'Data Mining',
          contact: '8379940820',
          email: 'kanadepoonam93@gmail.com'
        },
        {
          name: 'Prof. Shaikh R.F.',
          cv: 'test.pdf',
          image: 'Shaikh_R.F',
          designation: 'Assistant Professor',
          qualification: 'M.E(COMP)',
          experience: '01 Year',
          specialization: 'Cloud Computing',
          contact: '9665340680',
          email: 'shaikhrais9@gmail.com'
        },
        {
          name: 'Prof. Bharambe I. N.',
          cv: 'test.pdf',
          image: 'Bharambe_IN',
          designation: 'Assistant Professor',
          qualification: 'M.E(COMP)',
          experience: '07 Years',
          specialization: 'Computer Science & Engineering',
          contact: '9595434525',
          email: 'Ishwar.bharambe@gmail.com'
        },
        {
          name: 'Mr. Tuplondhe R. D.',
          cv: 'test.pdf',
          image: 'employee_placeholder_male',
          designation: 'Lab Assistant',
          qualification: 'Diploma',
          experience: '1 years',
          specialization: 'Hardware/Networking',
          contact: '7887742513',
          email: 'rakeshtuplondhe1234@gmail.com'
        },
        {
          name: 'Mr. Ansari A. A.',
          cv: 'test.pdf',
          image: 'employee_placeholder_male',
          designation: 'Technician',
          qualification: 'Diploma',
          experience: '03 Years',
          specialization: 'Computer Electronics',
          contact: '9272988109',
          email: 'arshad1419@gmail.com'
        },
        {
          name: 'Mr. Kahar V.P.',
          cv: 'test.pdf',
          image: 'employee_placeholder_male',
          designation: 'Peon',
          qualification: 'HSC',
          experience: '13 Years',
          specialization: 'none',
          contact: '9011614354',
          email: 'vijaykahar@gmail.com'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped/>
